module.exports = "<h1>{{'dashboard.pos.history' | translate}}</h1>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/dashboard/pos/chart/chart.html
 ** module id = 413
 ** module chunks = 0
 **/